import { render, staticRenderFns } from "./SystemConfigModal.vue?vue&type=template&id=d328c45c&"
import script from "./SystemConfigModal.vue?vue&type=script&lang=js&"
export * from "./SystemConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports